
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AziendeGrid extends Serenity.EntityGrid<AziendeRow, any> {
        protected getColumnsKey() { return AziendeColumns.columnsKey; }
        protected getDialogType() { return AziendeDialog; }
        protected getIdProperty() { return AziendeRow.idProperty; }
        protected getInsertPermission() { return AziendeRow.insertPermission; }
        protected getLocalTextPrefix() { return AziendeRow.localTextPrefix; }
        protected getService() { return AziendeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}